import MultiProvider from './MultiProvider';

export default MultiProvider;
export * from './MultiProvider';
